<template>
  <div class="pdf-container d-flex align-items-start">
    <div class="pdf-inner" :style="`height:calc(100vh - ${minusHeight}px);`">

      <div v-if="$store.state.app.isMobile" class="pdf-controls d-flex justify-content-between mg-b-20">
        <button @click="prevPage" :disabled="pageNum <= 1">
          <feather type="chevron-left"></feather>
        </button>
        <span class="text-white">{{ pageNum }} / {{ pageCount }}</span>
        <button @click="nextPage" :disabled="pageNum >= pageCount">
          <feather type="chevron-right"></feather>
        </button>
      </div>

      <img :style="`max-width: ${$store.state.app.isMobile?'90%':'90%'}`" :src="`${file.link}?page=${pageNum}&w=${$store.state.app.isMobile?'800':'1600'}`" />
      <!-- <canvas ref="pdfCanvas"></canvas> -->
    </div>
    <div v-if="!$store.state.app.isMobile" class="pdf-sidebar" :style="`height:calc(100vh - ${minusHeight}px);`">
      <div class="pdf-controls d-flex justify-content-between">
        <button @click="prevPage" :disabled="pageNum <= 1">
          <feather type="chevron-left"></feather>
        </button>
        <span class="text-white">{{ pageNum }} / {{ pageCount }}</span>
        <button @click="nextPage" :disabled="pageNum >= pageCount">
          <feather type="chevron-right"></feather>
        </button>
      </div>
      <div class="pdf-thumbs">
        <div 
          v-for="page in pageCount" 
          :key="page"
          class="pdf-thumb"
          :class="{ active: page === pageNum }"
          @click="goToPage(page)"
        >
        <img :src="`${file.link}?page=${page}&w=160&h=120&mode=crop`" />
          <!-- <canvas :ref="'thumb_' + page"></canvas> -->
          <div class="page-number">{{ page }}</div>
        </div>
      </div>
    </div>
    
  </div>
  <!-- <iframe
    v-if="fileReady"
    :src="`${file.link}#toolbar=0&navpanes=0`"
    :style="`
    width:100%; 
    height:calc(100vh - ${minusHeight}px);`"
    frameborder="0"
    ref="myIframe"
  ></iframe> -->
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import { request } from "@/api/all";

// PDF.js-ийг import хийх
// import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
// import 'pdfjs-dist/legacy/build/pdf.worker.entry';

// import * as pdfjsLib from 'pdfjs-dist/webpack';
// import 'pdfjs-dist/webpack/pdf.worker.entry';
// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.js`;

// import * as pdfjsLib from 'pdfjs-dist';
// // Worker-ийг тохируулах
// pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry');

// PDF.js-ийг import хийх
// import * as pdfjsLib from 'pdfjs-dist/build/pdf';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

// // Worker-ийг тохируулах
// pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0,
      pdfDoc: null,
      pageNum: 1,
      pageCount: 0,
      scale: 1.5,
      viewLog: {
        second: 0,
      },
    };
  },

  async mounted() {
    // console.log('mounted', this.propFileId);
    let _id = this.propFileId;
    if (_id == undefined) {
      _id = this.$route.params.id;
    }

    // if (this.$route.params.id) //# edited 250407
    if (_id > 0) {
      const res = await fileInheritedDetail({
        params: { id: _id }, 
        store: this.$store
      });
      
      this.file = res.data.file;
      // console.log('this.$route.params.id', this.$route.params.id, this.file)
      if(this.file.pageCount>0){
        await this.loadPDF();
      }
      //
    }
  },
  methods: {
    async updateViewLog(page, isFullView) {
      //let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }      
      if(this.file.pageCount == page+1){
        isFullView=true;
      }

      request({
        api: { method: "POST", url: "Media/UpdateVideoViewLog" },
        data: {
          attachId: _id,
          logId: this.viewLog.id,
          second: page,
          isFullView: isFullView != undefined ? isFullView : false,
        },
        store: this.$store,
      });
    },

    async renderThumbnails() {
      for (let pageNum = 1; pageNum <= this.pageCount; pageNum++) {
        const page = await this.pdfDoc.getPage(pageNum);
        const canvas = this.$refs['thumb_' + pageNum][0];
        const context = canvas.getContext('2d');

        const viewport = page.getViewport({ scale: 0.2 }); // Thumbnail хэмжээг бага байлгах
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;
      }
    },

    async loadPDF() {
      // console.log('loadPDF', this.file.link);
      try {
        //this.pdfDoc = await pdfjsLib.getDocument(this.file.link).promise;
        // this.pageCount = this.pdfDoc.numPages;
        this.pageCount = this.file.pageCount;
        
        await this.renderPage();
        //await this.renderThumbnails(); // Thumbnail-үүдийг үүсгэх
      } catch (error) {
        // console.error('PDF ачаалахад алдаа гарлаа:', error);
      }
    },

    async renderPage(pageNum) {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      try {
        request({
          api: { method: "POST", url: "Media/GetLastVideoViewLog" },
          data: {
            attachId: _id,
          },
          store: this.$store,
        }).then((res) => {
          if (res != false) {
            // console.log('sfrs', res);
            this.viewLog = res.data.viewLog;
            if (pageNum) {
              self.updateViewLog(pageNum ? pageNum : 0);
            }else{
              if(res.data.viewLog.second!=null && res.data.viewLog.second>0){
                this.pageNum= res.data.viewLog.second;
              }
            }
            //  else {
            //   if (res.data.viewLog.second > 0)
            //     this.curPage = res.data.viewLog.second;
            //   this.viewerOptions.initialViewIndex = this.curPage;
            // }
          }
        });
        // const page = await this.pdfDoc.getPage(this.pageNum);
        // const canvas = this.$refs.pdfCanvas;
        // const context = canvas.getContext('2d');

        // const viewport = page.getViewport({ scale: this.scale });
        // canvas.height = viewport.height;
        // canvas.width = viewport.width;

        // await page.render({
        //   canvasContext: context,
        //   viewport: viewport
        // }).promise;
      } catch (error) {
        console.error('Хуудас харуулахад алдаа гарлаа:', error);
      }
    },

    async prevPage() {
      if (this.pageNum <= 1) return;
      this.pageNum--;
      await this.renderPage(this.pageNum);
    },

    async nextPage() {
      if (this.pageNum >= this.pageCount) return;
      this.pageNum++;
      await this.renderPage(this.pageNum);
    },

    goToPage(pageNum) {
      this.pageNum = pageNum;
      this.renderPage(this.pageNum);
    }
  }
};
</script>

<style scoped>
.pdf-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.pdf-inner{
  overflow-y: auto;
  background: #525659;
  justify-items: center;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.pdf-inner img {
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  /* max-width: calc(75vw - 400px); */
  /* min-width: calc(75vw - 400px); */
}

button {
  padding: 5px 10px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.pdf-sidebar {
  width: 25%;
  padding: 10px;
  background: rgb(50 54 57);
  border-radius: 0 5px 0 0;
  overflow-y: auto;
}

.pdf-thumbs {
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.pdf-thumb {
  margin-bottom: 0;  /* Remove margin-bottom since we're using grid gap */
  cursor: pointer;
  position: relative;
  border: 2px solid transparent;
}

.pdf-thumb.active {
  border-color: #4CAF50;
  border-radius: 7px;
}

.pdf-thumb img {
  border-radius: 5px;
  width: 100%;
  height: auto;
  opacity: 0.8; /* Default opacity */
  filter: grayscale(100%); /* Convert to grayscale */
  transition: opacity 0.2s ease; /* Smooth transition */
}

.pdf-thumb:hover img,
.pdf-thumb.active img {
  filter: none;
  opacity: 1; /* Hover болон active үед тод харагдуулах */
}

.pdf-thumb.active .page-number {
  background: rgba(76, 175, 80, 0.8);  /* Using the same green as the buttons (#4CAF50) with some transparency */
}

.page-number {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
}
</style>
